<template>
  <div>
    <vue-apex-charts
        type="bar"
        height="400"
        :options="chartOptions"
        :series="series"
    />
  </div>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { capitalize, currency } from '../../../../../../utils/filter'

import VueApexCharts from 'vue-apexcharts'

import i18n   from '../../../../../../libs/i18n'
import moment from 'moment'

export default {
  components: {
    VueApexCharts
  },
  props: {
    opportunitiesPipeStatusChart: {
      type: Object,
      default: () => {}
    }
  },
  setup (props) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const isReady = computed(() => {
      return !(Object.keys(props.opportunitiesPipeStatusChart.chart.bar).length === 0 && props.opportunitiesPipeStatusChart.chart.bar.constructor === Object)
    })

    const prospectByMonths = computed(() => {
      let output = []

      if (isReady.value) {
        Object.values(props.opportunitiesPipeStatusChart.chart.bar).forEach(monthValArray => {
          output.push(monthValArray["Prospect"])
        })
      }

      return output
    })

    const leadByMonths = computed(() => {
      let output = []

      if (isReady.value) {
        Object.values(props.opportunitiesPipeStatusChart.chart.bar).forEach(monthValArray => {
          output.push(monthValArray["Lead"])
        })
      }

      return output
    })

    const enQualificationByMonths = computed(() => {
      let output = []

      if (isReady.value) {
        Object.values(props.opportunitiesPipeStatusChart.chart.bar).forEach(monthValArray => {
          output.push(monthValArray["En qualification"])
        })
      }

      return output
    })

    const sqlLeadQualifieByMonths = computed(() => {
      let output = []

      if (isReady.value) {
        Object.values(props.opportunitiesPipeStatusChart.chart.bar).forEach(monthValArray => {
          output.push(monthValArray["SQL/Lead Qualifié"])
        })
      }

      return output
    })

    const offreRealisaEnAttenteDeLaCommandeByMonths = computed(() => {
      let output = []

      if (isReady.value) {
        Object.values(props.opportunitiesPipeStatusChart.chart.bar).forEach(monthValArray => {
          output.push(monthValArray["Offre réalisée, en attente de la commande"])
        })
      }

      return output
    })

    const commandeReçueEnCoursDeLivraisonByMonths = computed(() => {
      let output = []

      if (isReady.value) {
        Object.values(props.opportunitiesPipeStatusChart.chart.bar).forEach(monthValArray => {
          output.push(monthValArray["Commande reçue, en cours de livraison"])
        })
      }

      return output
    })

    const suiviByMonths = computed(() => {
      let output = []

      if (isReady.value) {
        Object.values(props.opportunitiesPipeStatusChart.chart.bar).forEach(monthValArray => {
          output.push(monthValArray["Suivi"])
        })
      }

      return output
    })

    const clotureByMonths = computed(() => {
      let output = []

      if (isReady.value) {
        Object.values(props.opportunitiesPipeStatusChart.chart.bar).forEach(monthValArray => {
          output.push(monthValArray["Cloturé"])
        })
      }

      return output
    })

    const months = computed(() => {
      if (isReady.value) {
        return Object.keys(props.opportunitiesPipeStatusChart.chart.bar)
      } else {
        return []
      }
    })

    const series = computed(() => {
      return [
        {
          name: "Prospect",
          data: prospectByMonths.value,
        },
        {
          name: "Lead",
          data: leadByMonths.value,
        },
        {
          name: "En qualification",
          data: enQualificationByMonths.value,
        },
        {
          name: "SQL/Lead Qualifié",
          data: sqlLeadQualifieByMonths.value,
        },
        {
          name: "Offre réalisée, en attente de la commande",
          data: offreRealisaEnAttenteDeLaCommandeByMonths.value,
        },
        {
          name: "Commande reçue, en cours de livraison",
          data: commandeReçueEnCoursDeLivraisonByMonths.value,
        },
        {
          name: "Suivi",
          data: suiviByMonths.value,
        },
        {
          name: "Cloturé",
          data: clotureByMonths.value,
        },
      ]
    })

    const chartOptions = computed(() => {
      return {
        chart: {
          stacked: true,
          toolbar: {
            show: false,
          },
        },
        // colors: ['#826af9', '#d2b0ff', '#f8d3ff'],
        plotOptions: {
          bar: {
            columnWidth: '20',
            borderRadius: 5,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: true,
          position: 'top',
          fontSize: '14px',
          fontFamily: 'Montserrat',
          horizontalAlign: 'left',
        },
        stroke: {
          show: true,
          colors: ['transparent'],
        },
        grid: {
          xaxis: {
            lines: {
              show: true,
            },
          },
        },
        xaxis: {
          categories: months.value,
          labels: {
            formatter: (val) => {
              return capitalize(moment(val).format('MMMM YYYY'))
            }
          }
        },
        yaxis: {
          // opposite: isRtl,
          labels: {
            formatter: (val) => {
              return val
            }
          }
        },
        fill: {
          opacity: 1,
        },
      }
    })

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components

      // Data

      // Computed
      series,
      chartOptions,

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style
    scoped
    lang="scss"
>

</style>